import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import { NonFatalErrorCommand } from "slotworks/commands/error/non-fatal-error-command";
import { AlertRecordSchema } from "slotworks/integration/revolver/schema/alert-record-schema";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

class ErrorRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let alertRecord: AlertRecordSchema;

        if (data && data.data) {
            alertRecord = data.data as AlertRecordSchema;
        }

        return alertRecord && ( alertRecord.ALERT !== undefined && data.data.MESSAGE_BOX === undefined);
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let alertRecord: AlertRecordSchema;

        if (data && data.data) {
            alertRecord = data.data as AlertRecordSchema;
        }

        const errorId = alertRecord.ALERT.lang;

        if (errorId) {
            if (alertRecord.ALERT.fatal || alertRecord.ALERT.fatal === undefined) {
                FatalErrorCommand(errorId);

                let errorMessage = "";
                try {
                    errorMessage = JSON.stringify(data);
                } catch (e) {

                }

                //If Error is due to wrong session we throw basic error message and we will drop those messages in sentry
                try {
                    if(data['data']['ALERT']['lang'].indexOf('session')!==-1) {
                        errorMessage = "bad_session";
                    }
                }catch(e) {

                }   
            //    if(errorMessage != "bad_session") {
                    throw new Error(errorMessage);     
            //    }        
            } else {
                NonFatalErrorCommand(errorId).execute();
            }
        }

        return null;
    }
}

export default new ErrorRecordBuilder();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/builders/records/error-record-builder.ts